/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Section_DescInputs */

const en_landing_studio_section_desc = /** @type {(inputs: Landing_Studio_Section_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a prompt to generate, or upload an image and paint the part to change.`)
};

const zh_landing_studio_section_desc = /** @type {(inputs: Landing_Studio_Section_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写提示词生成图片，或上传图片并涂出要修改的部分。`)
};

/**
* | output |
* | --- |
* | "Write a prompt to generate, or upload an image and paint the part to change." |
*
* @param {Landing_Studio_Section_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_section_desc = /** @type {((inputs?: Landing_Studio_Section_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Section_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_section_desc(inputs)
	return zh_landing_studio_section_desc(inputs)
});
export { landing_studio_section_desc as "landing.studio.section_desc" }